import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle, WarningCircle } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import AuthActionShell, { authButtonClass, authInputClass } from "@/components/AuthActionShell";

function errorMessage(error) {
  const detail = error?.response?.data?.detail;
  return typeof detail === "string" ? detail : "The reset link could not be used.";
}

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState(token ? "" : "This password reset link is incomplete.");

  const submit = async (event) => {
    event.preventDefault();
    if (password !== confirm) return setError("The passwords do not match.");
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/reset-password", { token, password });
      setMessage(data.message);
    } catch (requestError) {
      setError(errorMessage(requestError));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthActionShell
      eyebrow="Account recovery"
      title="Choose a new password"
      description="The link is single-use and expires after 60 minutes. Your other Callsect sessions will be invalidated."
    >
      {message ? (
        <div className="auth-action-status is-success" role="status">
          <CheckCircle size={19} weight="fill" />
          <span>{message}</span>
        </div>
      ) : (
        <form onSubmit={submit} className="auth-action-form">
          <label className="auth-action-label">
            New password
            <input
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              required
              minLength={10}
              maxLength={72}
              autoComplete="new-password"
              className={authInputClass}
            />
          </label>
          <label className="auth-action-label">
            Confirm new password
            <input
              type="password"
              value={confirm}
              onChange={(event) => setConfirm(event.target.value)}
              required
              minLength={10}
              maxLength={72}
              autoComplete="new-password"
              className={authInputClass}
            />
          </label>
          {error && (
            <div className="auth-action-status is-error" role="alert">
              <WarningCircle size={19} weight="fill" />
              <span>{error}</span>
            </div>
          )}
          <button type="submit" disabled={loading || !token} className={authButtonClass}>
            {loading ? "Updating..." : "Update password"}
          </button>
        </form>
      )}
      <Link to="/login" className="auth-action-text-link">Sign in →</Link>
    </AuthActionShell>
  );
}
